/**
 * ag-grid-vue applies rowData on a deferred timer and deep-watches row objects.
 * A Tab that starts the next editor before that timer runs lands on a random cell.
 */

function schedule(fn) {
    globalThis.setTimeout(fn, 0);
}

export function editCellAfterGridFlush(api, rowId, colKey, key) {
    schedule(() => {
        if (!api || api.isDestroyed?.())
            return;
        const node = rowId != null ? api.getRowNode(String(rowId)) : null;
        const rowIndex = node?.rowIndex;
        if (rowIndex == null)
            return;
        api.ensureIndexVisible(rowIndex);
        api.startEditingCell({
            rowIndex,
            colKey,
            ...(key ? { key } : {}),
        });
    });
}

/**
 * While editing, Tab commits this cell and opens `colKey` on the same row.
 * Pass key `'Enter'` to open a select editor's dropdown.
 * Shift+Tab keeps the grid's normal backwards navigation.
 * Returns true when the event was handled.
 */
export function suppressTabToColumn(params, colKey, key) {
    const event = params?.event;
    if (!params?.editing || !event || event.key !== 'Tab' || event.shiftKey)
        return false;
    event.preventDefault();
    event.stopPropagation();
    const rowId = params.node?.id;
    const api = params.api;
    // Stop editing on the next turn so the value commits. Vue then flushes the
    // deep rowData watcher, which queues ag-grid-vue's own setTimeout(0).
    // The editor start has to be queued after that flush, or the refresh
    // destroys it and focus lands on a random cell.
    schedule(() => {
        if (!api || api.isDestroyed?.())
            return;
        api.stopEditing();
        queueMicrotask(() => {
            editCellAfterGridFlush(api, rowId, colKey, key);
        });
    });
    return true;
}
